"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileManagerPortalDataFetchSuccededAction = getFileManagerPortalDataFetchSuccededAction;
exports.fetchFileManagerPortalData = fetchFileManagerPortalData;
exports.getUpdateVidyardTosStatusSucceededAction = getUpdateVidyardTosStatusSucceededAction;
exports.getUpdateVidyardTosStatusFailedAction = getUpdateVidyardTosStatusFailedAction;
exports.getUpdateVidyardTosStatusAttemptedAction = getUpdateVidyardTosStatusAttemptedAction;
exports.getUpdateVidyardTosStatus = getUpdateVidyardTosStatus;

var _ActionTypes = _interopRequireDefault(require("FileManagerCore/actions/ActionTypes"));

var FileManagerPortalDataApi = _interopRequireWildcard(require("FileManagerCore/api/FileManagerPortalData"));

var _I18n = _interopRequireDefault(require("I18n"));

function getFileManagerPortalDataFetchSuccededAction(portalDataList) {
  return {
    type: _ActionTypes.default.FETCH_FILE_MANAGER_PORTAL_DATA_SUCCEEDED,
    portalDataList: portalDataList
  };
}

function fetchFileManagerPortalData(earlyRequesterPromise) {
  return function (dispatch) {
    FileManagerPortalDataApi.fetchFileManagerPortalData(earlyRequesterPromise).then(function (response) {
      dispatch(getFileManagerPortalDataFetchSuccededAction(response.get('objects')));
    }, function () {// no need to handle error
    });
  };
}

function getUpdateVidyardTosStatusSucceededAction(vidyardTosStatus) {
  return {
    type: _ActionTypes.default.UPDATE_VIDYARD_TOS_STATUS_SUCCEEDED,
    vidyardTosStatus: vidyardTosStatus,
    meta: {
      notification: {
        type: 'success',
        titleText: _I18n.default.text('FileManagerCore.notifications.updateVidyardToS.success.title'),
        message: _I18n.default.text('FileManagerCore.notifications.updateVidyardToS.success.message')
      }
    }
  };
}

function getUpdateVidyardTosStatusFailedAction() {
  return {
    type: _ActionTypes.default.UPDATE_VIDYARD_TOS_STATUS_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.updateVidyardToS.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.updateVidyardToS.error.message')
      }
    }
  };
}

function getUpdateVidyardTosStatusAttemptedAction() {
  return {
    type: _ActionTypes.default.UPDATE_VIDYARD_TOS_STATUS_ATTEMPTED
  };
}

function getUpdateVidyardTosStatus(newVidyardTosStatus) {
  return function (dispatch) {
    dispatch(getUpdateVidyardTosStatusAttemptedAction());
    FileManagerPortalDataApi.updateVidyardTosStatus(newVidyardTosStatus).then(function () {
      dispatch(getUpdateVidyardTosStatusSucceededAction(newVidyardTosStatus));
    }, function () {
      dispatch(getUpdateVidyardTosStatusFailedAction());
    });
  };
}